var _path, _path2, _g, _path3, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViettelPay = function SvgViettelPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M4.75 10.5a.75.75 0 0 1 .75-.75h25.8a.75.75 0 0 1 .75.75v15.9a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.35 11.35a1 1 0 0 1 1-1h24.1a1 1 0 0 1 1 1v14.2a1 1 0 0 1-1 1H6.35a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#viettel-pay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#viettel-pay_svg__b)",
    d: "M20.925 24.297c-.467.86-1.63 1.038-2.35.358l-8.215-7.76c-.921-.87-.431-2.407.82-2.568l13.368-1.722c1.219-.157 2.114 1.136 1.53 2.21z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#viettel-pay_svg__c)",
    fillOpacity: 0.8,
    d: "M24.838 16.753c.982.567 1.019 1.967.067 2.566l-9.238 5.816c-.969.61-2.245-.054-2.309-1.2l-.634-11.508c-.065-1.185 1.208-1.96 2.242-1.365z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#viettel-pay_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.165 16.4a.3.3 0 0 1-.144.073 1 1 0 0 1-.22.026s.015-.01-.05-.026c-.066-.017-.05-.042-.079-.074a18 18 0 0 1-.638-.753Q14 15.6 14 15.578q0-.075.112-.075h.43q.085 0 .129.018.045.018.08.072l.222.344q.013.021.05.022t.055-.022l.3-.394q.03-.037.063-.041l.048-.002.263.003q.045 0 .062.025a.04.04 0 0 1 .007.024q0 .013-.053.076-.05.062-.267.346a10 10 0 0 1-.336.425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.82 15.5h.086q.096 0 .125.03.033.028.042.12.01.09.011.351 0 .26-.018.383-.007.032-.048.056a.2.2 0 0 1-.106.028c-.086.004.234.006.12.006s-.117-.002-.219-.005a.2.2 0 0 1-.107-.028q-.039-.026-.046-.057a3 3 0 0 1-.018-.382q0-.262.009-.352.011-.09.041-.12.032-.03.128-.03M19.649 16.495a.2.2 0 0 1-.11-.025.13.13 0 0 1-.057-.084 3 3 0 0 1-.011-.354q0-.295.015-.385.02-.116.163-.119c.11-.002-.02 0 .78 0q.135 0 .135.104 0 .081-.12.081h-.502a.14.14 0 0 0-.078.02.06.06 0 0 0-.027.05v.1q0 .04.061.04h.417q.036 0 .054.005a.06.06 0 0 1 .037.025q.016.02.016.065t-.027.061a.2.2 0 0 1-.085.015h-.373q-.057 0-.08.018-.02.017-.02.053v.068q0 .06.093.06l1.055.002q.041 0 .073.015t.032.064a.12.12 0 0 1-.039.087.13.13 0 0 1-.091.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.275 15.86-.002.277q0 .06.03.091.031.03.13.03h.579q.105 0 .105.096 0 .075-.03.107-.03.033-.121.035a37 37 0 0 1-.638.005h-.4a.3.3 0 0 1-.135-.024q-.05-.026-.057-.068a3 3 0 0 1-.018-.38q0-.26.01-.35.01-.092.043-.12.031-.031.125-.031l.208-.002q.096 0 .126.03.031.03.038.099.007.068.007.205M18.095 16.39q-.002.03-.044.057a.23.23 0 0 1-.11.028c-.086.004.082.002-.04.002s.102.004 0 0a.23.23 0 0 1-.11-.028q-.042-.026-.044-.057c-.004-.14 0-.312 0-.41q0-.15.003-.22 0-.052-.078-.052h-.206a.2.2 0 0 1-.078-.014.06.06 0 0 1-.034-.048l-.002-.073c0-.024.005.043.006.026q.005-.028.037-.042a.2.2 0 0 1 .073-.015c.198-.002-.142-.005.197-.005q.507 0 .727.003.04.001.07.015.036.014.037.042c.003.017 0-.05 0-.027q0 .036-.002.07-.007.061-.112.062h-.206q-.077 0-.077.048.007.175.007.316c0 .094-.01.237-.014.323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.403 16.502a.2.2 0 0 1-.11-.025.13.13 0 0 1-.057-.085 3 3 0 0 1-.012-.353q0-.294.016-.385.018-.116.163-.119c.11-.002.415-.002 1.215-.002q.135 0 .135.103 0 .082-.119.082l-.939.002a.14.14 0 0 0-.077.02.06.06 0 0 0-.028.05v.1q0 .04.062.04h.416q.037 0 .055.005a.06.06 0 0 1 .037.025q.015.02.016.065 0 .045-.028.061a.2.2 0 0 1-.084.015h-.373q-.057 0-.08.018-.02.017-.02.053v.068q0 .06.093.06h.633q.041 0 .074.015t.032.063a.12.12 0 0 1-.04.087.13.13 0 0 1-.09.04zM19.103 16.393q-.002.03-.044.057a.23.23 0 0 1-.11.027c-.086.004.081.002-.04.002-.123 0 .102.004 0 0a.23.23 0 0 1-.11-.027q-.041-.027-.044-.057c-.004-.14 0-.312 0-.411q0-.15.002-.22 0-.052-.077-.052h-.206a.2.2 0 0 1-.078-.014.06.06 0 0 1-.034-.048l-.002-.072c0-.025.005.043.006.025q.004-.027.037-.041a.2.2 0 0 1 .073-.016c.198-.002-.142-.004.197-.004s.828-.002.974 0q.04.001.071.015.034.014.037.042c.003.017 0-.05 0-.027q0 .036-.002.07-.007.061-.113.062l-.453.002q-.078 0-.078.049.007.174.007.315c0 .095-.009.237-.013.323"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#viettel-pay_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.92 20.29a.21.21 0 0 1-.42 0v-2.77a.205.205 0 0 1 .411 0v.124h.013a.77.77 0 0 1 .3-.276.94.94 0 0 1 .463-.112q.236 0 .429.085.195.084.334.236.143.151.219.357.075.2.076.433 0 .232-.076.437-.075.206-.214.357a1 1 0 0 1-.335.241q-.196.085-.442.085a1 1 0 0 1-.428-.098.8.8 0 0 1-.317-.277h-.013zm1.392-1.923a1 1 0 0 0-.045-.286.7.7 0 0 0-.133-.245.6.6 0 0 0-.223-.17.7.7 0 0 0-.304-.062.7.7 0 0 0-.294.063.7.7 0 0 0-.224.17.8.8 0 0 0-.147.244.86.86 0 0 0 0 .58.726.726 0 0 0 .37.41q.135.064.295.063.174 0 .304-.062a.69.69 0 0 0 .356-.42 1 1 0 0 0 .045-.285M17.02 18.427q0-.259.08-.482.081-.228.224-.393.147-.165.348-.258a1.1 1.1 0 0 1 .446-.094.9.9 0 0 1 .362.071q.165.067.285.17v-.005a.183.183 0 1 1 .366 0v1.99a.2.2 0 0 1-.2.201.2.2 0 0 1-.199-.2q0-.059-.002-.14c-.036.047-.015.056-.063.104a.8.8 0 0 1-.357.205 1.005 1.005 0 0 1-.656-.053 1 1 0 0 1-.33-.241 1.2 1.2 0 0 1-.223-.375 1.5 1.5 0 0 1-.08-.5m1.134.843q.17 0 .321-.08a.8.8 0 0 0 .255-.21v-1.245a1 1 0 0 0-.268-.133.9.9 0 0 0-.304-.054.675.675 0 0 0-.527.241.8.8 0 0 0-.146.272 1.1 1.1 0 0 0-.054.352q0 .187.054.349a.8.8 0 0 0 .151.272.678.678 0 0 0 .518.236M20.666 18.931h.008l.537-1.523a.205.205 0 1 1 .384.143l-.916 2.335q-.054.134-.116.236a.7.7 0 0 1-.147.179.6.6 0 0 1-.201.116.8.8 0 0 1-.268.04q-.066 0-.138-.009c-.08-.005-.132-.082-.123-.162l.002-.018c.012-.11.123-.177.233-.177q.164 0 .245-.094a.9.9 0 0 0 .147-.258l.134-.353-.778-1.817a.213.213 0 1 1 .394-.163z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay_svg__a",
    width: 17.378,
    height: 13.979,
    x: 9.383,
    y: 12.592,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay_svg__d",
    width: 8.317,
    height: 1.204,
    x: 13.9,
    y: 15.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "viettel-pay_svg__e",
    width: 7.309,
    height: 3.5,
    x: 14.4,
    y: 17.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.533333 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_12536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5_12536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "viettel-pay_svg__b",
    x1: 26.844,
    x2: 13.664,
    y1: 22,
    y2: 12.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "viettel-pay_svg__c",
    x1: 13.816,
    x2: 15.257,
    y1: 12,
    y2: 24.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
};
export default SvgViettelPay;